import React from 'react';
import './FeaturesSection.css';

const FeaturesSection: React.FC = () => {
  return (
    <section className="features-section">
      <div className="features-container">
        {/* Notification Bar */}
        <div className="features-notification-bar">
          <span className="features-notification-text">Everything you need</span>
        </div>
        
        {/* Content Frame */}
        <div className="features-content">
          <div className="features-text-content">
            <h2 className="features-heading">Streamlined for easy management</h2>
            <p className="features-description">
              Enjoy customizable lists, team work tools, and smart tracking all in one place. 
              Set tasks, get reminders, and see your progress simply and quickly.
            </p>
          </div>
          
          {/* Feature Cards Grid */}
          <div className="features-cards-grid">
            <div className="feature-card">
              <div className="feature-card-image">
                <img src="/section-3-image-1.svg" alt="Integration ecosystem" className="feature-image" />
              </div>
              <div className="feature-card-content">
                <h3 className="feature-card-title">Integration ecosystem</h3>
                <p className="feature-card-description">
                  Enhance your productivity by connecting with your favorite tools, 
                  keeping all your essentials in one place.
                </p>
              </div>
            </div>
            
            <div className="feature-card">
              <div className="feature-card-image">
                <img src="/section-3-image-2.svg" alt="Goal setting and tracking" className="feature-image" />
              </div>
              <div className="feature-card-content">
                <h3 className="feature-card-title">Goal setting and tracking</h3>
                <p className="feature-card-description">
                  Define and track your goals, breaking down objectives into 
                  achievable tasks to keep your targets in sight.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection; 